import RSAA from "redux-api-middleware/es/RSAA";
import {rememberToken} from "../token";

const defaultHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

export const AUTHENTICATED = 'AUTHENTICATED';
export const SIGNED_OUT = 'SIGNED_OUT';
export const AUTH_EXPIRED = 'AUTH_EXPIRED';

export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_INIT_SUCCESS = 'AUTH_INIT_SUCCESS';
export const AUTH_INIT_ERROR = 'AUTH_INIT_ERROR';

export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_IN_SUCCESS = 'AUTH_SIGN_IN_SUCCESS';
export const AUTH_SIGN_IN_ERROR = 'AUTH_SIGN_IN_ERROR';

export const AUTH_REQUEST_PASSWORD_RESET = 'AUTH_REQUEST_PASSWORD_RESET';
export const AUTH_REQUEST_PASSWORD_RESET_SUCCESS = 'AUTH_REQUEST_PASSWORD_RESET_SUCCESS';
export const AUTH_REQUEST_PASSWORD_RESET_ERROR = 'AUTH_REQUEST_PASSWORD_RESET_ERROR';

export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD';
export const AUTH_RESET_PASSWORD_SUCCESS = 'AUTH_RESET_PASSWORD_SUCCESS';
export const AUTH_RESET_PASSWORD_ERROR = 'AUTH_RESET_PASSWORD_ERROR';

export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_SIGN_OUT_SUCCESS = 'AUTH_SIGN_OUT_SUCCESS';
export const AUTH_SIGN_OUT_ERROR = 'AUTH_SIGN_IN_ERROR';


export const signedIn = (name) => {
    return { type: AUTHENTICATED, name: name };
};

export const signedOut = () => {
    return { type: SIGNED_OUT };
};

export const expired = () => {
    return { type: AUTH_EXPIRED };
};

export const authInit = (namespace) => {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/users/me`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                AUTH_INIT,
                AUTH_INIT_SUCCESS,
                AUTH_INIT_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
};

export const signIn = (username, password) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/login`,
            method: 'POST',
            body: JSON.stringify({ user: { email: username, password: password } }),
            headers: defaultHeaders,
            types: [
                AUTH_SIGN_IN,
                {
                    type: AUTH_SIGN_IN_SUCCESS, payload: (action, state, res) => {
                        let token = (res.headers.get('Authorization') || '').split(' ')[1];
                        rememberToken(token);
                        return res.json();
                    }
                },
                AUTH_SIGN_IN_ERROR
            ],
            credentials: 'same-origin'
        }
    };

};

export const signOut = () => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/logout`,
            method: 'DELETE',
            headers: defaultHeaders,
            types: [
                AUTH_SIGN_OUT,
                AUTH_SIGN_OUT_SUCCESS,
                AUTH_SIGN_OUT_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const requestPasswordReset = (params) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/password`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                AUTH_REQUEST_PASSWORD_RESET,
                AUTH_REQUEST_PASSWORD_RESET_SUCCESS,
                AUTH_REQUEST_PASSWORD_RESET_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(params)
        },
        auth: true
    };

};

export const resetPassword = (params) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/password`,
            method: 'PUT',
            headers: defaultHeaders,
            types: [
                AUTH_RESET_PASSWORD,
                AUTH_RESET_PASSWORD_SUCCESS,
                AUTH_RESET_PASSWORD_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(params)
        },
        auth: true
    };

};